import { Injectable } from '@angular/core';
import { ToastController, ToastOptions } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  public users = []
  constructor(
    private toastController: ToastController
  ) { }

  async present(message:string, duration:number, color: ToastOptions['color']) {
    const toast = await this.toastController.create({
      message: message,
      duration: duration,
      color: color,
      buttons: [
        {
          icon: 'close',
          handler: () => { toast.dismiss(); }
        }
      ]
    });
    toast.present();
  }

  dissmis() {

  }
}
